import {
    SALESDOCUMENT_CREATE_REQUEST,
    SALESDOCUMENT_CREATE_SUCCESS,
    SALESDOCUMENT_CREATE_FAIL,
    SALESDOCUMENT_LIST_REQUEST,
    SALESDOCUMENT_LIST_SUCCESS,
    SALESDOCUMENT_LIST_FAIL,
    SALESDOCUMENT_DETAILS_REQUEST,
    SALESDOCUMENT_DETAILS_SUCCESS,
    SALESDOCUMENT_DETAILS_FAIL,
    SALESDOCUMENT_UPDATE_REQUEST,
    SALESDOCUMENT_UPDATE_SUCCESS,
    SALESDOCUMENT_UPDATE_FAIL,
    SALESDOCUMENT_DELETE_REQUEST,
    SALESDOCUMENT_DELETE_SUCCESS,
    SALESDOCUMENT_DELETE_FAIL,
    SALESDOCUMENT_CREATE_RESET,

  } from '../constants/salesDocumentConstants';
  
  export const salesDocumentCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case SALESDOCUMENT_CREATE_REQUEST:
        return { loading: true };
      case SALESDOCUMENT_CREATE_SUCCESS:
        return { loading: false, success: true, salesDocument: action.payload };
      case SALESDOCUMENT_CREATE_FAIL:
        return { loading: false, error: action.payload };
      case SALESDOCUMENT_CREATE_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const salesDocumentListReducer = (state = { salesDocuments: [] }, action) => {
    switch (action.type) {
      case SALESDOCUMENT_LIST_REQUEST:
        return { ...state, loading: true }; // Preserve existing sales documents while loading
      case SALESDOCUMENT_LIST_SUCCESS:
        return { loading: false, salesDocuments: action.payload };
      case SALESDOCUMENT_LIST_FAIL:
        return { loading: false, error: action.payload, salesDocuments: state.salesDocuments };
      default:
        return state;
    }
  };
  
  export const salesDocumentDetailsReducer = (state = { salesDocument: {} }, action) => {
    switch (action.type) {
      case SALESDOCUMENT_DETAILS_REQUEST:
        return { loading: true, ...state };
      case SALESDOCUMENT_DETAILS_SUCCESS:
        return { loading: false, salesDocument: action.payload };
      case SALESDOCUMENT_DETAILS_FAIL:
        return { loading: false, error: action.payload };
      case 'SALESDOCUMENT_DETAILS_RESET':
        return {
          salesDocument: null,
          loading: false,
          error: null
        };
      default:
        return state;
    }
  };
  
  export const salesDocumentUpdateReducer = (state = { salesDocument: {} }, action) => {
    switch (action.type) {
      case SALESDOCUMENT_UPDATE_REQUEST:
        return { loading: true };
      case SALESDOCUMENT_UPDATE_SUCCESS:
        return { loading: false, success: true, salesDocument: action.payload };
      case SALESDOCUMENT_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const salesDocumentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case SALESDOCUMENT_DELETE_REQUEST:
        return { loading: true };
      case SALESDOCUMENT_DELETE_SUCCESS:
        return { loading: false, success: true };
      case SALESDOCUMENT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };